<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <form [formGroup]="form">
    <div>
      <span><b>Dist. Exclusivo (DE)</b></span>
      <div class="grid grid-cols-3 gap-3 mt-3">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Código</mat-label>
          <input matInput type="text" formControlName="code" />
        </mat-form-field>
      </div>
    </div>

    <div class="mt-3">
      <app-company-form
        #companyForm
        [states]="states"
        [parentFormGroup]="form"
      />
    </div>

    <div class="mt-3">
      <span><b>Outras Informações</b></span>      
      <div class="grid grid-cols-3 gap-3 mt-3">
        <app-select-form-field
          label="LB"
          [control]="productLine"
          [options]="productLines"
          [display]="codeDisplayName"
        />
        <app-select-form-field
          label="GRV Responsável"
          [control]="user"
          [options]="users"
        />
      </div>
      <div class="flex flex-row mt-3 gap-4">
        <mat-checkbox formControlName="active">Ativo</mat-checkbox>
        <!-- <mat-checkbox formControlName="deleted">Excluido</mat-checkbox> -->
      </div>
    </div>

    <div class="mt-3">
     
      <div class="mt-3">
        <div class="flex flex-row flex-1 gap-4 justify-between mb-1">
          <span><b>Account Managers</b></span>
          <a mat-flat-button color="accent" class="mic-btn" aria-label="Adicionar AM" (click)="onAddAMClick()">
            <mat-icon role="img" aria-label="add_circle">add_circle</mat-icon> Adicionar AM
          </a>
        </div>
        <mic-table [dataSource]="accountManagerDataSource" [config]="tableConfig">
          <ng-container *micCellTemplate="let item; name: 'actionsCell'">
            <button mat-icon-button color="primary" matTooltipClass="big-tooltip" matTooltip="Remover Account Manager" (click)="removeAccountManager(item.id)">
              <mat-icon>close</mat-icon>
            </button>
          </ng-container>
        </mic-table>
      </div>
    </div>
  </form>
</mic-spinner-overlay>

<mic-modal #userModal (result)="onUserModalClosed($event)"></mic-modal>
<ng-template #userModalContent>
    <p class="mb-4">Selecione o usuário:</p>
    <div class="flex flex-col gap-4" [formGroup]="userForm">
        <app-select-form-field label="Usuário" [control]="accountManager" [options]="accountManagerOptions"
            [display]="userDisplayName" />        
    </div>
</ng-template>